<script lang="ts" setup>
import Link4 from '@/components/Button/Link4.vue'
import FavoriteBtn from '@/components/Card/FavoriteBtn.vue'
import type { IEvent } from '@/utils/types/Event'
import { dateFormat } from '@/utils/helper'
const route = useRoute()
const id = route.params.eventId as string
const emit = defineEmits(['update:email'])
const props = defineProps({
  event: {
    type: Object as PropType<IEvent>,
    default: {}
  },
  email: {
    type: String,
    default: ''
  },
  submitSubscribe: {
    type: Function,
    default: () => { }
  }
})

const isOpen = ref(false)

</script>

<template>
  <div class="events-inner__info">
    <div class="events-inner__function">
      <!-- <button class="h-fav"><svg-icon name="icon-favorite" />收藏</button> -->
      <FavoriteBtn class="h-fav" :id="event.id" :is-favorite="event.is_favorite" />
      <Share class="events-inner__function__share" :border="false" color="color-gray-1" />
    </div>
    <div class="events-inner__priceBox" :class="{ stop: event.status === '已截止' }">
      <div class="events-inner__price" v-if="event.min_price !== event.max_price">
        {{ formatNumber(event.min_price) }} ~ {{ formatNumber(event.max_price) }}
      </div>
      <div class="events-inner__price" v-else>{{ formatNumber(event.min_price) }}</div>
      <Link4 :to="`/events/${id}/apply`" linkTitle="立即報名" v-if="event.status === '報名中'" />
    </div>
    <div class="events-inner__detail" :class="{ isOpen: isOpen }" @click="isOpen = !isOpen">
      活動詳情
      <svg-icon name="icon-arrow-down" />
    </div>
    <transition>
      <div class="events-inner__info__content" v-show="isOpen">
        <div class="events-inner__info__item">
          <div class="events-inner__info__subtitle">地點</div>
          <div class="events-inner__info__title">
            {{ event.place_name }}<br />
            {{ event.address }}
          </div>
          <nuxt-link :to="`https://www.google.com/maps/place/${event.address}`" class="events-inner__info__link"
            target="_blank">Google 導航</nuxt-link>
        </div>
        <div class="events-inner__info__item">
          <div class="events-inner__info__subtitle">活動時間</div>
          <div class="h__dateRange black">
            <div class="h__dateItem">
              <div class="h__dateItem__top">{{ event.started_date }}</div>
              <div class="h__dateItem__bottom">({{ dateFormat(`${event.started_date} ${event.started_time}`,
                'dd')
                }}) {{
                  event.started_time }}</div>
            </div>
            <div class="h__separate">~</div>
            <div class="h__dateItem">
              <div class="h__dateItem__top">{{ event.ended_date }}</div>
              <div class="h__dateItem__bottom">({{ dateFormat(`${event.started_date} ${event.started_time}`,
                'dd')
                }}) {{
                  event.ended_time }}</div>
            </div>
          </div>
        </div>
        <div class="events-inner__notify">
          <div class="events-inner__notify__title">訂閱相關活動</div>
          <div class="events-inner__notify__bottom">
            <el-input :model-value="email" class="h-input2" placeholder="請輸入您的email"
              @input="$emit('update:email', $event)" />
            <button class="events-inner__notify__submit" @click="props.submitSubscribe">提交</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.events-inner {
  &__detail {
    display: flex;
    justify-content: center;
    align-items: center;
    height: toRem(42);
    background-color: $color-gray-2;
    color: $color-black-1;
    cursor: pointer;

    svg {
      width: toRem(16);
      height: toRem(16);
      margin-left: toRem(5);
      transform: rotate(180deg);
      transition: all 0.5s;
    }

    &.isOpen {
      svg {
        transform: rotate(0deg);
      }
    }
  }

  &__info {
    &__content {
      padding: toRem(24);
      background-color: $color-white-1;
    }

    &__status {
      display: inline-block;
      padding: toRem(10) toRem(24);
      background-color: $color-brand-4_1;
      font-size: toRem(14);
      color: $color-white-1;
      font-weight: 700;
    }

    &__item {
      margin-bottom: toRem(30);
    }

    &__subtitle {
      font-size: toRem(14);
      color: $color-gray-1;
    }

    &__title {
      font-size: toRem(16);
      font-weight: 700;
    }

    &__link {
      font-size: toRem(16);
      font-weight: 700;
      color: $color-gray-1;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__priceBox {
    display: flex;
    width: 100%;
    background-color: $color-white-1;

    &.stop {
      padding-top: toRem(10);
      padding-bottom: toRem(10);
    }

    a {
      width: 38%;
    }
  }

  &__price {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 62%;
    font-size: toRem(48);
    padding-left: toRem(24);
    font-weight: 700;
    font-family: $font-TextaAlt;
    color: $color-gray-1;
    line-height: 1;

    @include max-media(990) {
      font-size: toRem(28);
    }

    &::before {
      content: 'NT$';
      display: block;
      font-size: toRem(20);
    }
  }

  &__function {
    display: flex;
    justify-content: space-between;
    padding-top: toRem(14);
    padding-bottom: toRem(14);
    padding-left: toRem(24);
    padding-right: toRem(24);
  }

  &__notify {
    &__title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: toRem(10) toRem(10);
      font-size: toRem(14);
      color: $color-white-1;
      background-color: $color-gray-2;
      margin-left: toRem(-24);
      margin-right: toRem(-24);
    }

    &__bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: toRem(12) toRem(24);
    }

    .h-input2,
    &__submit {
      width: calc((100% - 12px) / 2);
    }

    &__submit {
      border: none;
      background-color: $color-gray-2;
      border-radius: toRem(30);
      color: $color-white-1;
      height: toRem(30);
      transition: all 0.6s cubic-bezier(0.87, 0, 0.13, 1);

      &:hover {
        background-color: $color-gray-1;
      }
    }
  }
}
</style>
